var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("rect",{"fill":"none","id":"canvas_background","height":"20","width":"20","y":"-1","x":"-1"})),React.createElement("g",{"key":1},[React.createElement("path",{"id":"svg_1","fill":"none","d":"m0,0l36,0l0,36l-36,0l0,-36z","key":0}),React.createElement("path",{"stroke":"null","fill":"#ffffff","id":"svg_2","d":"m-0.032791,16.116232l17.974645,0l0,-2.234056l-17.974645,0l0,2.234056zm0,-5.957483l17.974645,0l0,-2.234056l-17.974645,0l0,2.234056zm0,-8.19154l0,2.234056l17.974645,0l0,-2.234056l-17.974645,0z","key":1})])]);
}

Menu.defaultProps = {"width":"18","height":"18"};

module.exports = Menu;

Menu.default = Menu;
